
<template>
  <v-app id="onArrq">
    <v-main>
    <v-container fluid>  
    <v-card>

      <v-row no-gutters class="py-2">
        <v-col cols="5" class="px-2">
            <v-text-field v-model="arrq.arrq_oms_kort" label="Short description" dense ></v-text-field>
        </v-col>
        <v-col class="px-2" cols=2>  
         <v-select v-model="arrq.gebr_code_indien" :items="gebr_code_indienKeuzes" item-value="gebr_code" item-text="gebr_oms" label="Rquested by" dense></v-select>
        </v-col> 
         <v-col cols="1" class="px-2">
                          <v-menu
                            v-model="hulp1Menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            readonly 
                            offset-y
                            min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="arrq.arrq_indien_dat"
                              label="Request date"
                              v-on="on"
                              dense
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="arrq.arrq_indien_dat2" :first-day-of-week="1" @input="arrq.arrq_indien_dat = $moment(arrq.arrq_indien_dat2).format('DD-MM-YYYY'); hulp1Menu = false"></v-date-picker>
                          </v-menu>  
                          </v-col>  
      
      <v-col class="px-2" cols=1>  
         <v-select v-model="arrq.gebr_code_dev" :items="gebr_code_devKeuzes" item-value="gebr_code" item-text="gebr_oms" label="Developer" dense></v-select>
        </v-col> 
      </v-row>  


      <v-row no-gutters>
        <v-col cols="12" class="px-2">
      <v-textarea v-model="arrq.arrq_oms_lang" :value=arrq.arrq_oms_lang rows="10" label="Long description"></v-textarea>
        </v-col>
      </v-row>        


      <v-row no-gutters>
        <v-col class="px-2" cols=2>  
         <v-select v-model="arrq.arrq_prio" :items="prio_codeKeuzes" item-value="prio_code" item-text="prio_oms" label="Priority" dense></v-select>
        </v-col>
        <v-col class="px-2" cols=2>  
         <v-select v-model="arrq.arrq_status" :items="stat_codeKeuzes" item-value="stat_code" item-text="stat_oms" label="Status" dense></v-select>
        </v-col>
      </v-row>  
      

     
         
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="arrq.arrq_save === 'Yes'" class="primary ma-2" small @click="deleteArrq(arrq)">Delete</v-btn><br>
       <v-btn v-if="arrq.arrq_save === 'Yes'" class="primary ma-2" small @click="saveArrq(arrq)">Save</v-btn><br>
    </v-card-actions>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar,
  },
  props: ['arrq_encrid'],
  data() {
    return {
      arrq: {},
      prio_codeKeuzes: [],
      stat_codeKeuzes: [],
      gebr_code_indienKeuzes: [],
      gebr_code_devKeuzes: [],
      hulpMenu1: false,
    }  
  },
  mounted() {
      var deze = this;
      this.$axios
        .post("ares/json/ares/syst/ref/arrq/getArrq.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getArrq"
          },
          getArrq: {
             arrq_encrid: this.arrq_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.arrq = res.data.getArrq;
            res.data.getArrq.prio_codeKeuzes.forEach(function(prio) {
             deze.prio_codeKeuzes.push(prio); 
            });
            res.data.getArrq.gebr_code_indienKeuzes.forEach(function(gebr_indien) {
             deze.gebr_code_indienKeuzes.push(gebr_indien); 
            });
             res.data.getArrq.gebr_code_devKeuzes.forEach(function(gebr_dev) {
             deze.gebr_code_devKeuzes.push(gebr_dev); 
            });
            res.data.getArrq.stat_codeKeuzes.forEach(function(stat) {
             deze.stat_codeKeuzes.push(stat); 
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    saveArrq(arrq) { 
      this.$axios
        .post("ares/json/ares/syst/ref/arrq/saveArrq.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveArrq"
          },
          saveArrq: {
            arrq: arrq
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveArrq.text,
              color: res.data.saveArrq.color
            });
            if (res.data.saveArrq.color == "success") {
                  setTimeout(() => { this.$router.reload('/syst/ref/arrq/searchArrq'); }, 2000);   
            }
          }
        })
    },
    deleteArrq(arrq) { 
      this.$axios
        .post("ares/json/ares/syst/ref/arrq/rmArrq.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmArrq"
          },
          rmArrq: {
            arrq: arrq
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmArrq.text,
              color: res.data.rmArrq.color
            });
            if (res.data.rmArrq.color == "success") {
                  setTimeout(() => { this.$router.reload('/syst/ref/arrq/searchArrq'); }, 2000);   
            }
          }
        })
    }
  }    

};

</script> 
